import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "ad" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_StudentChoiceHeader = _resolveComponent("StudentChoiceHeader")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_loader, {
        key: 0,
        stretch: true,
        inverse: true
      }))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createVNode(_component_StudentChoiceHeader, {
          style: _normalizeStyle(_ctx.themeStyle)
        }, null, 8, ["style"]),
        _createElementVNode("div", {
          class: "page",
          style: _normalizeStyle(_ctx.themeStyle)
        }, [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.error && !_ctx.externalLink)
              ? (_openBlock(), _createElementBlock("h1", _hoisted_2, "Something has gone wrong."))
              : _renderSlot(_ctx.$slots, "ad", { key: 1 })
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "ad-banner-left-nav" }, null, -1)),
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ], 4)
      ], 64))
}